var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-940fb87a-724f-455f-abb2-2874ee9f4f27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 494 494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-b5669c03-f262-41e7-9bec-00cd7917d481",
    x1: 0.68282,
    y1: 792.47326,
    x2: 0.68282,
    y2: 298.47326,
    gradientTransform: "translate(371.18282 792.47326) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09103,
    stopColor: "#c0bdd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ac150d6a-2dd2-4513-9113-293769395ccc",
    x1: 214.23544,
    y1: 779.42663,
    x2: 261.0311,
    y2: 287.64805,
    gradientTransform: "translate(371.18282 792.47326) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06068,
    stopColor: "#c0bdd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21856,
    stopColor: "#d0cde1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#e9e8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79334,
    stopColor: "#f9f9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-55099552-91d0-489d-9892-159cbacd7c06"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m451,247c0,112.6661-91.334,204-204,204v43c136.4143,0,247-110.5856,247-247S383.4143,0,247,0v43c112.666,0,204,91.334,204,204Z",
    style: {
      fill: "url(#uuid-b5669c03-f262-41e7-9bec-00cd7917d481)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,247c0,136.4144,110.5857,247,247,247v-43c-112.666,0-204-91.3339-204-204,0-112.666,91.334-204,204-204V0C110.5857,0,0,110.5857,0,247Z",
    style: {
      fill: "url(#uuid-ac150d6a-2dd2-4513-9113-293769395ccc)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.8569f18af18df239fc9de58280d2aa21.svg";
export { ForwardRef as ReactComponent };